import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { Redirect, Route, Switch } from "react-router";
import Form from "./form";
import Change from "./change";
import UserName from "./username";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";

class Index extends Component<RoutedViewProps> {
	render() {
		const pp = this.props.match.url;
		return <React.Fragment>
			<div className="sso-main-container">
				<div className="container">
					<div className="row no-gutters dld-sso-wrapper">
						<div className="dld-sso-grey dld-sso-login-grey">
							<div className="dld-sso-white">
								<Switch>
									<Route path={ [ pp ] } exact={ true }>
										<Redirect to={ pp + "/form" }/>
									</Route>
									<Route path={ pp + "/form" } component={ Form }/>
									<Route path={ pp + "/change" } component={ Change }/>
									<Route path={ pp + "/username" } component={ UserName }/>
								</Switch>
							</div>
							<div className="col-md-12 sso-footer-txt">
                                    <span>
                                        { Strings.if_issue_with_login }
                                    </span>
								<div>
									<a
										href="mailto:info@dubailand.gov.ae"
										className="underline">info@dubailand.gov.ae</a>
									<span>+971-8004488</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>;
	}
}

export default Index;
